<script>

import { angularInvoke } from '/vodalys/vvuejs'

export default {
  translate25COntext: "vprojector",
  props: ["component", "handler"],
  data: () => {
    return {
      pending: false,
    };
  },
  methods: {
    async create(title, date) {
      this.pending = true;
      await this.handler.action(this.component["#id"], "create", [title, date]);
      this.pending = false;

      window.location.hash = this.component.created_url;
    },

    async start() {
      
  
      let zis = this

      angularInvoke(function (v17Modal, $rootScope, $rootElement, vTranslateService) {
        v17Modal.inputAndDate($rootScope, $rootElement.find('body'), {
							title: zis.$vt('Set a title and a date for your new project'),
							placeholder: zis.component.data.title,
							ok: function (title, date) {
                console.log('inputAndDateCB', title, date)
                return zis.create(title, date)
							},
              okLabel: $vt('Start'),
              yesType: 'highlight'
						})
      })

    }

  }
};
</script>

<template>
  <div class="vprojector-card" :class="{'pending':pending, 'disabled':!component['#actions']['create']}" @click="start()">
    <div class="icon">
      <f-icon :icon="component.data.icon" figma></f-icon>
    </div>
    <div class="title">{{ component.data.title }}</div>
    <div class="list">
      <div
        class="list-item"
        v-for="(list_item, index) in component.data.list"
        :key="index"
      >
        <div class="list-item-icon"><f-icon icon="fa6-check"></f-icon></div>
        <div>{{ $vt(list_item.text) }}</div>
      </div>
    </div>
    <div class="cost">{{ component.data.cost }} credits/h</div>
    <div class="viewers">{{ component.data.viewers }}</div>
    <f-button v-if="component['#actions']['create']" :pending="pending" class="view" type="highlight"
      >Start <f-icon icon="fa6-arrow-right"></f-icon
    ></f-button>
	<div v-if="!component['#actions']['create']" class="permissionlabel">
		{{component.permission_label}}
	</div>
  </div>
</template>

<style lang="scss" scoped>
.vprojector-card {

  .cost {
    margin-top: 16px;
    font-weight: bold;
    font-size: 12px;
    line-height: 125%;
  }

  .viewers {
    margin-top: 2px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 125%;
    color: #161615;
  }
  
  &.disabled {
	cursor: default;
    opacity: 1;
    pointer-events: none;
  }
  
  .permissionlabel {
	margin-top: 17px;
    text-align: center;
    color: #1890d3;
  }
  
}
</style>
